import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_PERIODS = "/api/periods"

export async function getPeriods(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_PERIODS
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getPeriod(id) {
  let url = REACT_APP_API_URL + ENDPOINT_PERIODS + "/" + id
  return await getObject(url)
}

export async function putPeriod(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_PERIODS + "/" + id
  return await putObject(url, putValues)
}

export async function patchPeriod(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_PERIODS + "/" + id
  return await patchObject(url, patchValues)
}

export async function postPeriod(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_PERIODS
  return await postObject(url, postValues)
}
